import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import type { BrandInfo } from './types';

interface Props {
  brand: BrandInfo;
  to: string;
  collapsed?: boolean;
}

export function Brand({ brand, to, collapsed = false }: Props): JSX.Element {
  const { t } = useTranslation('common');
  return (
    <Link
      to={to}
      aria-label={t('nav.brand_aria', { defaultValue: brand.name })}
      className="flex h-14 shrink-0 items-center gap-2 px-3"
    >
      <span
        aria-hidden="true"
        className="grid h-8 w-8 shrink-0 place-items-center rounded-md bg-primary text-sm font-semibold text-primary-foreground"
      >
        {brand.initial.charAt(0).toUpperCase()}
      </span>
      {collapsed ? null : (
        <span className="flex min-w-0 flex-col leading-tight">
          <span className="truncate text-sm font-semibold text-foreground" title={brand.name}>
            {brand.name}
          </span>
          <span className="text-[11px] uppercase tracking-wider text-muted-foreground">
            {t(brand.subtitleKey)}
          </span>
        </span>
      )}
    </Link>
  );
}
